<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item style="margin-left: 14px;">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="姓名"
      ></el-input>
    </el-form-item>
    <el-form-item style="margin-left: 14px;margin-right: 0px;">
      <butn btntype="primary" title="查询" @click.native="searchUser"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";

export default {
  name: "search",
  components: { butn },
  data() {
    return {
      size: "small",
      filters: undefined
    };
  },
  created() {
    const emptyObj = Object.create(null);
    this.filters = emptyObj;
  },
  methods: {
    resetData() {
      //重置
      this.filters = {};
      this.searchUser();
    },
    searchUser() {
      this.$emit("search", this.filters);
    }
  }
};
</script>
